
import React from 'react';

import {
  HashRouter as Router,
  // BrowserRouter as Router,
  Route
} from 'react-router-dom';

import App from './App';
import app from './app_data/index';

const Routes = () => (
  <Router basename={ app.deployPath } >
    <div>
      <Route exact path="/" component={App}/>
      <Route path="/resume" component={app.resume}/>
    </div>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js